import ReservationSurname from './ReservationSurname';

export default ReservationSurname;
